import { styled } from 'styled-components';
import { decode } from 'html-entities';
import { useCallback, useContext } from 'react';

import * as api from '../../../../api';

import { ReactComponent as ExternalLinkIcon } from '../../../../assets/external-link.svg';
import { ConfigurationContext } from '../../../../context/configurationContext';

interface Props {
  sourceDocument: api.Assistant.SourceDocument;
  sourceNumber: number;
  messageId: string;
}

const Document: React.FC<Props> = ({
  sourceDocument,
  sourceNumber,
  messageId,
}) => {
  const configurationContext = useContext(ConfigurationContext);

  const createClickedLog = useCallback(
    async (documentId: string) => {
      if (!configurationContext?.id) return;
      if (!configurationContext.sessionId) return;
      try {
        await api.client.Assistant.createLog({
          action:
            api.Log.AssistantAuditAction.AssistantPatientClickedSourceDocument,
          assistantId: configurationContext.id,
          sessionId: configurationContext.sessionId,
          messageId,
          documentId,
        });
      } catch (error) {
        console.error('Could not add log', error);
      }
    },
    [configurationContext?.id, configurationContext?.sessionId, messageId],
  );

  return (
    <SourceLink
      href={sourceDocument.metadata.url}
      target="_blank"
      onClick={() => createClickedLog(sourceDocument.metadata._additional.id)}
    >
      <Link>
        {decode(sourceDocument.metadata.title ?? `Source ${sourceNumber}`)}
      </Link>
      <LinkIcon />
    </SourceLink>
  );
};

const LinkIcon = styled(ExternalLinkIcon)`
  margin-left: 8px;
  overflow: visible;
  color: var(--action-color);
  height: 16px;
`;

const SourceLink = styled.a`
  border: 1px solid var(--border-color);
  background-color: transparent;
  padding: 5px 10px;
  width: auto;
  border-radius: 4px;
  text-decoration: none;
  transition: opacity 0.4s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  height: 40px;

  &:hover {
    opacity: 0.75;
  }
`;

const Link = styled.span`
  white-space: nowrap;
  color: var(--action-color);
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default Document;
